let instance = null;
const enforcer = Symbol('constManagerenforcer');

export class ConstManager {
    /**
     * @type {import('@goodt-wcore/managers').IConstManagerHash}
     * @private
     */
    _constants = {};

    /**
     * Constructor
     *
     * @param {symbol} enforcer  singleton enforcer
     */
    constructor(_enforcer = enforcer) {
        if (_enforcer !== enforcer) {
            throw new Error(`Instantiation failed: use ConstManager.instance`);
        }
        this._constants = {};
    }

    /**
     * @return {ConstManager}
     */
    static get instance() {
        if (!instance) {
            instance = new ConstManager();
        }
        return instance;
    }

    /**
     *
     * @param {string} value
     * @return {boolean}
     */
    static isConstant(value) {
        return value.match(/^%[^%]+%$/) !== null;
    }


    /**
     * @param {string} value
     * @return {string}
     */
    interpolate(value) {
        return value.replace(/(%[^%]+%)/g, (m) => this.getConstValue(m))
    }

    /**
     * Return key value or key if no value found
     *
     * @param {string} key  key
     * @return {any} value
     */
    getConstValue(key) {
        if (typeof key !== 'string' || !this._constants[key]) {
            return key;
        }
        return this._constants[key];
    }

    /**
     * Set the constants hash
     *
     * @param {import('@goodt-wcore/managers').IConstManagerHash} constants
     */
    setConstantsHash(constants = {}) {
        this._constants = constants;
    }

    /**
     * Return the constants hash
     *
     * @return {import('@goodt-wcore/managers').IConstManagerHash}
     */
    getConstantsHash() {
        return this._constants;
    }
}
